import React from "react"

export const ScrollableContainer: React.FC = ({ children }) => {
    return (
        <div
            className="p-3 d-flex flex-grow-1"
            style={{
                overflowX: "auto",
                overflowY: "auto",
            }}
        >
            <div className="d-inline-block flex-grow-1">
                {children}
            </div>
        </div>
    )
}
